import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import {ReactComponent as Loading} from '../../images/icons/General/loading-01.svg';

import { usersService } from '../../Services';

const Teams = ({data, changeValue, changeSelectValue, userId, teamList}) => {
    const [TeamPreference1, setTeamPreference1] = useState({});
    const [TeamPreference2, setTeamPreference2] = useState({});
    const [TeamPreference3, setTeamPreference3] = useState({});
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        setError('');
        setSuccess(false);
        setLoading(true);

        let message = '';

        if (!data.TeamPreference1 && data.groupId > 2)
            message = 'Please, choose at leat one team preference';

        if (!message) {
            const res = await usersService.edit({
                'editType': 'Teams',
                'TeamPreference1': data.TeamPreference1,
                'TeamPreference2': data.TeamPreference2,
                'TeamPreference3': data.TeamPreference3,
            }, (userId || 0));

            if (res.res === 'OK') {
                setSuccess(true);
            } else {
                setError(res.error);
            }
        } else {
            setError(message);
        }
        setLoading(false);
    };
    // eslint-disable-next-line
    

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            flex: '1',
            height: '42px'
          }),
        control: (provided, state) => ({
          ...provided,
          border: '1px solid #D0D5DD',
          '&:hover': {
            boxShadow: '0 0 1px #5D3FC5'
          }
        })
    }

    useEffect(() => {
        if (data.TeamPreference1)
            setTeamPreference1(teamList.filter(item => item.value === data.TeamPreference1));

        if (data.TeamPreference2)
            setTeamPreference2(teamList.filter(item => item.value === data.TeamPreference2));

        if (data.TeamPreference3)
            setTeamPreference3(teamList.filter(item => item.value === data.TeamPreference3));
    }, [setTeamPreference1, setTeamPreference2, setTeamPreference3, data, teamList]);

    return (
        <>
            <p className="orgs-alert">Fields in this tab are specific to this organization and are not shared with the other AAUS Organization Members.</p>
            <form onSubmit={handleSubmit} className={error ? 'required' : ''}>
                <div className="form-column">
                    <label>Team Preference 1</label>
                    <Select className={`select ${TeamPreference1 ? '' : 'required'}`} options={teamList} onChange={(value) => changeSelectValue('TeamPreference1', value, setTeamPreference1)} styles={customStyles} required value={TeamPreference1} />
                </div>
                <div className="form-column">
                    <label>Team Preference 2<span>(Optional)</span></label>
                    <Select className={`select ${TeamPreference2 ? '' : 'required'}`} options={teamList} onChange={(value) => changeSelectValue('TeamPreference2', value, setTeamPreference2)} styles={customStyles} required value={TeamPreference2} />
                </div>
                <div className="form-column">
                    <label>Team Preference 3<span>(Optional)</span></label>
                    <Select className={`select ${TeamPreference3 ? '' : 'required'}`} options={teamList} onChange={(value) => changeSelectValue('TeamPreference3', value, setTeamPreference3)} styles={customStyles} required value={TeamPreference3} />
                </div>
                <div className="form-submit">
                    <button type="submit" className="primary">{loading ? <Loading className="btn-loader" alt="loader" /> : ''}Save</button>
                    {error ? <div className="error">{error}</div> : ''}
                    {success ? <div className="success">Profile was successfully updated</div> : ''}
                </div>
            </form>
        </>
    )
};

export default Teams;